/**
 * useTrack — client-side activation-funnel event beacon (T2.8 / ISSUE-200).
 *
 * Only use for events the server cannot observe (onboarding step views, paywall views).
 * All other funnel events are emitted server-side. If the user has not granted analytics
 * consent, the API silently returns 204 without writing — no client-side check needed.
 */
import type { AppEventName } from '@nutians/shared/schemas';
import { useCallback } from 'react';
import { api } from '../api.js';

export function useTrack() {
  return useCallback(
    async (name: AppEventName, props: Record<string, unknown> = {}): Promise<void> => {
      try {
        await api.POST('/me/events', {
          body: { name, props, client: 'web' },
        });
      } catch {
        // Never surface tracking errors to the user.
      }
    },
    [],
  );
}
